export default "<div [ngClass]=\"absConfig.layout.navbar.primaryBackground\">\n    <abs-navigation layout=\"horizontal\"></abs-navigation>\n</div>\n";